import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react"; //Limitless imports

import { useCustomerMessageContext } from "../customer-message/CustomerMessageContext";
import { submitSuggestedAnswerFeedback } from "../../apis/customer-message-api/CustomerMessageAPI";
import { MESSAGE_STATE_NEW } from "../../utils";
var INITIAL_STATE = {
  suggestedAnswerSelection: null,
  clearSuggestedAnswers: false,
  dialoguesVisibility: true
};
export var useCustomerSuggestedAnswers = function useCustomerSuggestedAnswers() {
  var _useCustomerMessageCo = useCustomerMessageContext(),
      message = _useCustomerMessageCo.message,
      updateMessageState = _useCustomerMessageCo.updateMessageState,
      fetchMessage = _useCustomerMessageCo.fetchMessage;

  var messageId = message.messageId,
      accessKey = message.accessKey;

  var _React$useState = React.useState(INITIAL_STATE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      customerSAState = _React$useState2[0],
      setCustomerSAState = _React$useState2[1];

  var selectSuggestedAnswer = function selectSuggestedAnswer(dialogueId) {
    setCustomerSAState(_objectSpread({}, customerSAState, {
      suggestedAnswerSelection: dialogueId
    }));
  };

  var updateDialogueVisiblity = function updateDialogueVisiblity(isVisible) {
    setCustomerSAState(_objectSpread({}, customerSAState, {
      dialoguesVisibility: isVisible
    }));
  };

  var submitSuggestedAnswer = function submitSuggestedAnswer(callback) {
    submitSuggestedAnswerFeedback(message, customerSAState.suggestedAnswerSelection, function () {
      fetchMessage(messageId, accessKey);
      updateDialogueVisiblity(true);
      callback();
    });
  };

  var rejectSuggestedAnswer = function rejectSuggestedAnswer() {
    setCustomerSAState(_objectSpread({}, customerSAState, {
      clearSuggestedAnswers: true
    })); //Wait for the SA animation to complete before making this call.

    setTimeout(function () {
      setCustomerSAState(_objectSpread({}, customerSAState, {
        dialoguesVisibility: true,
        clearSuggestedAnswers: true
      }));
      submitSuggestedAnswerFeedback(message, null, function () {
        updateMessageState(MESSAGE_STATE_NEW);
      });
    }, 400);
  };

  return {
    customerSAState: customerSAState,
    selectSuggestedAnswer: selectSuggestedAnswer,
    updateDialogueVisiblity: updateDialogueVisiblity,
    submitSuggestedAnswer: submitSuggestedAnswer,
    rejectSuggestedAnswer: rejectSuggestedAnswer
  };
};